<nav class="navbar topnav-navbar navbar-fixed-top">
    <button id="sidebar-toggler" class="hidden-md-up" type="button" (click)="sidebarToggler()">
        &#9776;
    </button>
    <a class="hidden-md-up theme-name" href="Javascript:void(0);" [routerLink]="['']">Globus Prenotazioni</a>
    <div class="collapse navbar-toggleable-sm">
        <a class="navbar-brand" href="Javascript:void(0);" [routerLink]="['']">Globus Prenotazioni</a>
        <ul class="nav navbar-nav">
            <li *ngIf="showTopBanner" class="nav-item">
                <div class="alert-danger" style="padding:10px 120px 10px 120px"><b>ATTENZIONE! </b> Ambiente
                    <b>{{envName}}</b></div>
            </li>
        </ul>
        <ul class="nav navbar-nav pull-right navbar-right">

            <li class="nav-item profile">
                <div class="btn-group dropdown" [class.active]="profileOpen" [class.open]="profileOpen">
                    <a a (click)="toggleProfileOpen()" id="profile-lg">
                        <i class="fa fa-user"></i>
                        <!-- <img src="{{ foto }}" class="topnav-img" alt="">  -->
                        <span class="hidden-md-down" style="margin-left:10px">{{ email }}</span>
                    </a>
                    <ul class="dropdown-menu" aria-labelledby="profile-lg">
                        <!-- <li role="menuitem"><a class="dropdown-item" [routerLink]="['profile']" (click)="toggleProfileOpen()">Profilo</a></li> -->
                        <li role="menuitem">
                            <a class="dropdown-item" (click)="logoutClicked()">
                                <i class="fa fa-sign-out"></i>
                                Logout
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
        </ul>
    </div>
    <ul class="nav navbar-nav pull-right hidden-md-up hidd">
        <li class="nav-item profile-xs">
            <div dropdown>
                <!-- <a dropdownToggle id="profile-sm">
                    <img src="{{ foto }}" class="topnav-img" alt="">
                </a> -->
                <ul class="dropdown-menu" aria-labelledby="profile-sm">
                    <!-- <li role="menuitem"><a class="dropdown-item" [routerLink]="['profile']">Profilo</a></li> -->
                    <!-- <li class="divider dropdown-divider"></li> -->
                    <li role="menuitem"><a class="dropdown-item" [routerLink]="['']">Logout</a></li>
                </ul>
            </div>
        </li>
    </ul>
</nav>